import { render, staticRenderFns } from "./NotificationsAlert.vue?vue&type=template&id=f9b99010&scoped=true&"
import script from "./NotificationsAlert.vue?vue&type=script&lang=js&"
export * from "./NotificationsAlert.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsAlert.vue?vue&type=style&index=0&id=f9b99010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b99010",
  null
  
)

export default component.exports